import classNames from "classnames";

import { Typography } from "../Typography";
import styles from "./Heading3.module.scss";

export const Heading3 = ({
  as = "h3",
  className,
  color,
  children,
  plain = false,
}) => (
  <Typography
    className={classNames(className, styles.element)}
    color={color}
    as={as}
    plain={plain}
  >
    {children}
  </Typography>
);
